<div class="chips-new">{{ 'new' | translate | uppercase }}</div>
